import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBolt, faShieldHalved, faLaptop, faClipboardCheck, faFlag, faScaleBalanced } from '@fortawesome/free-solid-svg-icons';

const diffs = [
    { icon: faBolt, color: '#c084fc', title: '50ms Response', desc: 'Faster than any LLM' },
    { icon: faShieldHalved, color: '#f87171', title: 'Zero Hallucination', desc: 'Only cites loaded docs' },
    { icon: faLaptop, color: '#60a5fa', title: 'Runs on a Laptop', desc: '> 1GB. No cloud needed.' },
    { icon: faClipboardCheck, color: '#34d399', title: 'Deep Audit Trail', desc: 'Every output traced' },
    { icon: faFlag, color: '#fbbf24', title: 'Data Sovereignty', desc: 'Processing stays local' },
    { icon: faScaleBalanced, color: '#c084fc', title: 'Regulatory Ready', desc: 'Built for regulation' },
];

const DifferentiatorsSection = () => (
    <section className="differentiators-strip rounded">
        <div className="differentiators-grid-overlay" />
        <Container style={{ position: 'relative', zIndex: 1 }}>
            <Row className="g-4 text-center justify-content-center">
                {diffs.map((d, i) => (
                    <Col xs={6} md={4} lg={2} key={i}>
                        <div className="diff-item">
                            <FontAwesomeIcon icon={d.icon} className="diff-icon w-100 text-center" style={{ color: d.color }} />
                            <div className="diff-title">{d.title}</div>
                            <div className="diff-desc">{d.desc}</div>
                        </div>
                    </Col>
                ))}
            </Row>
        </Container>
    </section>
);

export default DifferentiatorsSection;
